import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { UserModel } from '../models/user.model';
import { UsersApi } from '../../../api/users/users.api';

@Injectable()
export class UsersService {

    /** Gets an array of the users in the current account */
    readonly accountUsers$ = this.usersApi.getAllUsersFromCurrentAccount().pipe(
        map(apiUsers => apiUsers.map(apiUser => new UserModel(apiUser))),
        shareReplay({ bufferSize: 1, refCount: true })
    );

    constructor(
        private usersApi: UsersApi
    ) {}


    /** Gets an user model based on the provided user ID */
    getUser(id: number): Observable<UserModel> {
        return this.accountUsers$.pipe(
            map(users => users.find(user => user.id === id))
        );
    }

    /** Gets an array of user models based on the provided array of user IDs */
    getUsers(ids: number[]): Observable<UserModel[]> {
        return this.accountUsers$.pipe(
            map(users => users.filter(user => ids.includes(user.id)))
        );
    }

    getUserNameByID(id: number): Observable<string | null> {
        return this.accountUsers$.pipe(
            map(users => users.find(user => user.id === id)?.getDisplayName() ?? null)
        );
    }
}
